module.exports = function () {
    var lvalue = [].slice.call(arguments, 0, arguments.length - 2);
    var rvalue = arguments[arguments.length - 2];
    var options = arguments[arguments.length - 1];
    
    if (lvalue.indexOf(rvalue) === -1) {
        return options.inverse(this);
    } else {
        return options.fn(this);
    }
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/equalsany.js
// module id = 52
// module chunks = 0